import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor() {
    this.applicationEventSubject = new BehaviorSubject<string>('');
    this.applicationEventSubscription = this.applicationEventSubject.asObservable();
  }

  applicationEventSubscription:Observable<string>;
  applicationEventSubject:BehaviorSubject<string>;
  isApplicationBusy:boolean = false;

  showGlobalSpinner():void {
    this.isApplicationBusy = true;
    this.applicationEventSubject.next('SHOWGLOBALSPINNER');
  }

  hideGlobalSpinner():void {
    this.isApplicationBusy = false;
    this.applicationEventSubject.next('HIDEGLOBALSPINNER');
  }

  playBeep() {
    const context = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = context.createOscillator();
    const gainNode = context.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(1000, context.currentTime); // Frequency in Hz
    oscillator.connect(gainNode);
    gainNode.connect(context.destination);

    oscillator.start();
    oscillator.stop(context.currentTime + 0.15); // Beep duration (150ms)
  }

  
}
